<template>
    <div class="">
        <div class="question main-container hidden-sm-and-down">
              <div class="container pc">
            <el-tabs :tab-position="tabPosition" v-model="activeName">
                <el-tab-pane label="常见问题"  name="question">
                <div style="margin-left: 8%;  border-bottom: 1px solid #00383F;">
                    <el-collapse v-model="active" accordion v-for="(item,index) in Datalist" :key="index" @change="handleChange">
                    <el-collapse-item :title=" item.title " :name=item.id>
                        <div style="text-align: left">{{ item.content }}</div>
                    </el-collapse-item>
                    </el-collapse>
                </div>
                </el-tab-pane>
                <el-tab-pane label="退货规定" name="second">
                <div class="sales" v-for="(items,index) in salesInfo" :key="index">
                    <h4>{{ items.title }}</h4>
                    <p v-html="items.content">{{ items.id }}{{ items.content}}</p>
                </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        </div>
        <div class="hidden-md-and-up mob">
           <div>
                <img src="../../static/mobile/question.png" alt="">
           </div>
                    <ul class="tab-tilte">
                        <li @click="cur=0"><a href="#" :class="{active:cur==0}">常见问题</a></li>
                        <span></span>
                        <li @click="cur=1" ><a href="#" :class="{active:cur==1}">退货规定</a></li>
                    </ul>
                    <div class="tab-content">
                        <div class="cont" v-show="cur==0">
                            <div v-for="(item,index) in Datalist" :key="index">
                                <h3>{{ item.title }}</h3>
                                <p>{{ item.content }}</p>
                            </div>
                            
                        </div>
                        <div class="contrig" v-show="cur==1">
                            <div class="sales" v-for="(items,index) in salesInfo" :key="index">
                                <h4>{{ items.title }}</h4>
                                <p v-html="items.content">{{ items.content}}</p>
                            </div>
                        </div>
                </div>
        </div>
    </div>
</template>

<script>
import {quest_url,salesInfo_url} from '../request/api'
export default {
    name: 'Question',

    components: {  },

    directives: {  },

    data() {
        return {
                tabPosition: 'left',
                salesInfo: '',
                activeName:'question',
                Datalist: '',
                active: 1,
                cur:0
        };
    },

    mounted() {
        if(this.$route.query.id == 2){
            this.activeName = 'second'
            this.cur = 1
        }
    },

    methods: {
        handleChange(){
            console.log(document.getElementsByClassName("el-collapse-item__header is-active"))
        }
    },
    created(){
        quest_url().then((res)=>{
            this.Datalist = res.data.data
        })
          salesInfo_url().then((res)=>{
            this.salesInfo = res.data.data
        })
    }
};
</script>

<style lang="less" scoped>
.question{
     width: 100%;
     color:#00383F ;
     .container{
         padding: 5%;
         .sales{
             text-align: left;
             margin-left: 8%;
             h4{
                 font-size: 26px;
                 font-weight: 400;
             }
             p{
                 font-size: 18px;
                 line-height:30px;
             }
         }
     }
}
/deep/.el-collapse-item__header{
    background: unset!important;
    color:#00383F!important;
    font-size: 20px;

}
/deep/.el-collapse-item__content{
    color:#00383F!important;
    font-size: 16px;
}
/deep/.el-collapse{
     border-top: 1px solid #00383F!important; 
        border-bottom: 1px solid #00383F!important;
}

/deep/.el-collapse-item__wrap{
    background: unset!important;
}
/deep/.el-tabs__item.is-active{
    color: #BB2041!important;
}
/deep/.el-tabs__active-bar{
    background-color: #BB2041!important;
}
/deep/.el-tabs__item:hover {
    color: unset;
}
/deep/.el-tabs__item{
    font-size: 26px;
}
/deep/.el-tabs__item:first-child{
    margin-bottom: 10%;
}


 @media (max-width: 991px) {
     .mob{
         img{
             width: 100%;
         }
         .tab-tilte{
             width: 100%;
             height: 0.995rem;
             display: flex;
             li{
                 width: 50%;
                 line-height: 0.995rem;
                   font-size: 0.33rem;
                    font-weight: 900;
                    color: #00383F;
             }
              span{
                    width: 0.01rem;
                    height: 0.5rem;
                    background: rgba(0, 56, 63, 0.5);
                    margin-top: 0.2rem;
                }
        .active{
                border-bottom: 0.06rem solid #00383F;
                display: inline-block;
                line-height: 0.9rem;
                }
         }
         .tab-content{
            background: url(../../static/mobile/productbg.png) no-repeat;
            border-top: 1px solid rgba(0, 56, 63, 0.5);
            background-size: 100% 100%;
            padding-bottom: 3rem;
            .cont{
                text-align: left;
                div{
                    border-bottom: 1px solid rgba(0, 56, 63, 0.5);
                    padding: 0 0.4rem;
                    h3{
                        font-size: 0.3rem;
                        font-weight: 900;
                        margin: 0.5rem 0 0.3rem 0;
                    }
                    p{
                        font-size: 0.22rem;
                        font-weight: 400;
                        margin-bottom: 0.37rem;
                    }
                }
            }
         }
         .contrig{
             text-align: left;
             margin: 0 0.4rem;
             padding-top: 0.36rem;
            .sales{
                h4{
                    margin-top: 0.2rem;
                     letter-spacing: 0.01rem; 
                     font-size: 0.3rem;
                }
                p{
                    font-size: 0.25rem;
                    line-height: 0.3rem;
                }
            }
         }
     }
 }
</style>


// WEBPACK FOOTER //
// src/view/question.vue